/* unplugin-vue-components disabled */import { render } from "./Head.vue?vue&type=template&id=736bc87d&scoped=true"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"

import "./Head.vue?vue&type=style&index=0&id=736bc87d&lang=scss&scoped=true"
import "./Head.vue?vue&type=style&index=1&id=736bc87d&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上海杉达-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736bc87d"]])

export default __exports__